import "../_namespaces.js";
window.AssessmentViewer ??= {};
window.AssessmentViewer.Scoring ??= {};

AssessmentViewer.Scoring.Sum = {
  calculate(points) {
    return this.sum(points);
  },

  sum(points) {
    return points.reduce((memo, num) => memo + (num || 0), 0);
  },
};
